"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentsStore_1 = require("./PaymentsStore");
exports.default = PaymentsStore_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/data/PaymentsStore/index.js
// module id = 78
// module chunks = 0 1